import Vue from "vue";
import Vuex from "vuex";
import costCenters from "../../models/centrosDeCosto/costCenters";
import service from "../../services/centrosDeCostos/costCenters";
import clocks from "../../store/centrosDeCosto/clocks";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    costCenters: [],
    headers: {
      centroDeCosto: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
      ],
      clocks: [
        {
          text: "Nombre",
          value: "nombre",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha Desde",
          value: "fecDesde",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha Hasta",
          value: "fecHasta",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Código de registración extendida",
          value: "codRegisEx",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    },
    allHeaders: [],
    open: false,
    openClock: false,
    mode: "Agregar centro de Costos",
    modeClock: "Agregar reloj",
    new: {},
    edit: {},
    editClock: {},
    itemDelete: {},
    openDelete: false,
    openDeleteClock: false,
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setCostCenters(state, data) {
      state.costCenters = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setOpenClock(state, data) {
      state.openClock = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setOpenDeleteClock(state, data) {
      state.openDeleteClock = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setModeClock(state, data) {
      state.modeClock = data;
    },
    setLiquidations(state, data) {
      state.liquidations = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setEditClock(state, data) {
      state.editClock = data;
    },
  },
  actions: {
    async getCostCenters(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getCostCenters();
          state.commit("setCostCenters", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getCostCentersId({ state, commit }, Id) {
      try {
        const data = await state.service.getCostCentersId(Id);

        if (Array.isArray(data.relojes)) {
          data.relojes.forEach((relojes) => {
            if (relojes.fecHasta) {
              relojes.fecHasta =
                moment
                  .utc(relojes.fecHasta)
                  .subtract(1, "days")
                  .format("YYYY-MM-DD") + "T00:00:00.000Z";
            }
          });
        }

        commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async getLiquidationModels(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLiqModelos();
          state.commit("setLiquidations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async add(state) {
      try {
        const response = await state.state.service.addCostCenter(
          state.state.new
        );
        const newItem = costCenters.fromJson(response.data);
        const updated = [newItem, ...state.state.costCenters];
        state.commit("setCostCenters", updated);
        return true;
      } catch (error) {
        return false;
      }
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteCostCenter(state.state.itemDelete)
            .then(() => {
              let options = state.state.costCenters;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setCostCenters", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editCostCenter(state.state.edit)
            .then(() => {
              let item = state.state.edit;
              let options = state.state.costCenters;
              options = options.map((option) => {
                if (option.id !== item.id) {
                  return option;
                }
                item = costCenters.fromJson({
                  csCostoId: item.id,
                  nombre: item.nombre,
                  cat: item.cat,
                  ws: item.ws,
                });
                return item;
              });

              state.commit("setCostCenters", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async addClock(state) {
      try {
        const response = await state.state.service.addClockToCostCenter(
          state.state.new
        );
        const newClock = response.data;
        const nombreReloj = clocks.state.clocks.find(
          (clock) => clock.id === newClock.relojId
        );
        const formattedNewClock = {
          ...newClock,
          nombre: nombreReloj.name,
          fecDesde: moment.utc(newClock.fecDesde).format("DD-MM-YYYY"),
          fecHasta: newClock.fecHasta
            ? moment
                .utc(newClock.fecHasta)
                .subtract(1, "days")
                .format("DD-MM-YYYY")
            : "",
        };

        const updatedEdit = {
          ...state.state.edit,
          relojes: [...state.state.edit.relojes, formattedNewClock],
        };
        state.commit("setEdit", updatedEdit);
        return true;
      } catch (error) {
        return false;
      }
    },

    async deleteClock(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteClockToCostCenter(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.relojes;
              options = options.filter((option) => {
                return (
                  option.relojId !== state.state.itemDelete.relojId ||
                  option.nombre !== state.state.itemDelete.nombre ||
                  option.fecDesde !== state.state.itemDelete.fecDesde ||
                  option.fecHasta !== state.state.itemDelete.fecHasta
                );
              });

              let edit = { ...state.state.edit };
              edit.relojes = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editClock(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editClockToCostCenter(state.state.editClock)
            .then(() => {
              let item = state.state.editClock;
              item.fecDesde = moment(item.fecDesde).format("DD-MM-YYYY");
              item.fecHasta = moment(item.fecHasta).format("DD-MM-YYYY");
              let options = state.state.edit.relojes;
              options = options.map((option) => {
                if (option.relojId !== item.relojId) {
                  return option;
                }

                return item;
              });

              let edit = { ...state.state.edit };
              edit.relojes = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
